import request from '@/utils/request'

// 获取菜单
export function getMenus () {
  return request({
    url: '/index',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/menu.js